"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeBottomCta = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const react_router_dom_1 = require("react-router-dom");
const HomeBottomCtaWrapper = styled_components_1.default.div `
  position: fixed;
  bottom: 0;
  width: 100vw;
  padding: 16px;
  margin: 0 auto;
  background: transparent;
  text-align: center;
  z-index: 10;
  button {
    max-width: 600px;
    background-color: ${(props) => props.backgroundColor} !important;
    color: ${(props) => props.color} !important;
  }
`;
const HomeBottomCta = ({ data }) => {
    const history = (0, react_router_dom_1.useHistory)();
    const location = (0, react_router_dom_1.useLocation)();
    const { title, payload, type } = data;
    const handleClick = () => {
        if (type === "internal_browser_call_to_action_button" ||
            type === "external_browser_call_to_action_button") {
            return window.open(payload.url, "_blank");
        }
        const url = new URL(payload.url);
        return history.push({
            pathname: url.pathname,
            search: location.search,
        });
    };
    return (react_1.default.createElement(HomeBottomCtaWrapper, { color: payload.onTertiaryColor, backgroundColor: payload.tertiaryColor },
        react_1.default.createElement(material_1.Button, { variant: "contained", fullWidth: true, size: "large", role: "button", onClick: handleClick }, title)));
};
exports.HomeBottomCta = HomeBottomCta;
exports.default = exports.HomeBottomCta;
